import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCmErL-0NtP9icg8hotkc7t7ESsXVfY81I",
  authDomain: "reviewapp-22949.firebaseapp.com",
  projectId: "reviewapp-22949",
  storageBucket: "reviewapp-22949.appspot.com",
  messagingSenderId: "848347117175",
  appId: "1:848347117175:web:aa790ac46b2bb3f3013872"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { db, auth, provider };
